// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Array contains list of on-device pay wallets that are registererd to accept push provision of input pan
 * @export
 * @interface IOnDeviceWallet
 */
export interface IOnDeviceWallet {
    /**
     * dentifier of button or log asset of wallet, usable in Get Assets API for fetching that asset
     * @type {string}
     * @memberof IOnDeviceWallet
     */
    asset_id: string;
    /**
     * The name of the token requester to be displayed to the end user
     * @type {string}
     * @memberof IOnDeviceWallet
     */
    consumer_facing_entity_name: string;
    /**
     * Sequence number in list
     * @type {string}
     * @memberof IOnDeviceWallet
     */
    sequence_number: string;
    /**
     * Identifier of wallet or merchant that can accept a push provision
     * @type {string}
     * @memberof IOnDeviceWallet
     */
    wallet_id: string;
    /**
     * Is Issuer Pan Reference needed in Push Proivsion request
     * @type {boolean}
     * @memberof IOnDeviceWallet
     */
    issuer_pan_reference_id_needed: boolean;
    /**
     * Is Return URL needed in Push Provision request
     * @type {boolean}
     * @memberof IOnDeviceWallet
     */
    return_uri_needed: boolean;
}

/**
 * Check if a given object implements the IOnDeviceWallet interface.
 */
export function instanceOfIOnDeviceWallet(value: object): value is IOnDeviceWallet {
    if (!('asset_id' in value) || value['asset_id'] === undefined) return false;
    if (!('consumer_facing_entity_name' in value) || value['consumer_facing_entity_name'] === undefined) return false;
    if (!('sequence_number' in value) || value['sequence_number'] === undefined) return false;
    if (!('wallet_id' in value) || value['wallet_id'] === undefined) return false;
    if (!('issuer_pan_reference_id_needed' in value) || value['issuer_pan_reference_id_needed'] === undefined) return false;
    if (!('return_uri_needed' in value) || value['return_uri_needed'] === undefined) return false;
    return true;
}

export function IOnDeviceWalletFromJSON(json: any): IOnDeviceWallet {
    return IOnDeviceWalletFromJSONTyped(json, false);
}

export function IOnDeviceWalletFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOnDeviceWallet {
    if (json == null) {
        return json;
    }
    return {
        
        'asset_id': json['assetId'],
        'consumer_facing_entity_name': json['consumerFacingEntityName'],
        'sequence_number': json['sequenceNumber'],
        'wallet_id': json['walletId'],
        'issuer_pan_reference_id_needed': json['issuerPanReferenceIdNeeded'],
        'return_uri_needed': json['returnUriNeeded'],
    };
}

export function IOnDeviceWalletToJSON(json: any): IOnDeviceWallet {
    return IOnDeviceWalletToJSONTyped(json, false);
}

export function IOnDeviceWalletToJSONTyped(value?: IOnDeviceWallet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetId': value['asset_id'],
        'consumerFacingEntityName': value['consumer_facing_entity_name'],
        'sequenceNumber': value['sequence_number'],
        'walletId': value['wallet_id'],
        'issuerPanReferenceIdNeeded': value['issuer_pan_reference_id_needed'],
        'returnUriNeeded': value['return_uri_needed'],
    };
}

